import { deleteSpells, putSpell } from "@/common/character/spells";

export interface SpellsStore {
  // Elemental vs divine will be the spell category
  elementalSpellgroups: {
    interdictions: Array<SpellItemStore>;
    spaceTime: Array<SpellItemStore>;
    illusions: Array<SpellItemStore>;
    scrying: Array<SpellItemStore>;
    charms: Array<SpellItemStore>;
    astralPower: Array<SpellItemStore>;
    arcana: Array<SpellItemStore>;
    terramancy: Array<SpellItemStore>;
    pyromancy: Array<SpellItemStore>;
    aquamancy: Array<SpellItemStore>;
    aeromancy: Array<SpellItemStore>;
  };
  divineSpellgroups: {
    life: Array<SpellItemStore>;
    light: Array<SpellItemStore>;
    death: Array<SpellItemStore>;
    darkness: Array<SpellItemStore>;
    flora: Array<SpellItemStore>;
    fauna: Array<SpellItemStore>;
    tempest: Array<SpellItemStore>;
    turmoil: Array<SpellItemStore>;
    equillibrium: Array<SpellItemStore>;
    effigy: Array<SpellItemStore>;
  };
  arcaneBattery: number;
  arcaneBatteryId: number;
}

export interface SpellItemStore {
  name: string;
  rank: number;
  known: boolean;
  id: number;
}

export default {
  namespaced: true,
  state: (): SpellsStore => ({
    // Elemental vs divine will be the spell category
    arcaneBattery: 0,
    arcaneBatteryId: 0,
    elementalSpellgroups: {
      interdictions: [
        { name: "Shield", rank: 0, known: false, id: 0 },
        { name: "Resist Magic", rank: 1, known: false, id: 0 },
        { name: "Halt Magic", rank: 2, known: false, id: 0 },
        { name: "Dispel", rank: 2, known: false, id: 0 },
        { name: "Steal Energy", rank: 3, known: false, id: 0 },
        { name: "Mage Armor", rank: 3, known: false, id: 0 },
        { name: "Delay", rank: 3, known: false, id: 0 },
        { name: "Counterspell", rank: 4, known: false, id: 0 },
        { name: "Silent Ward", rank: 5, known: false, id: 0 },
        { name: "Sorcerous Shield", rank: 5, known: false, id: 0 },
        { name: "Arcane Shield", rank: 6, known: false, id: 0 },
        { name: "Backlash", rank: 7, known: false, id: 0 },
        { name: "Forcelock", rank: 7, known: false, id: 0 },
        { name: "Redirect", rank: 8, known: false, id: 0 },
        { name: "Silent Field", rank: 9, known: false, id: 0 },
        { name: "Arcane Death", rank: 10, known: false, id: 0 },
      ],
      spaceTime: [
        { name: "Pause Object", rank: 0, known: false, id: 0 },
        { name: "Adjust Gravity", rank: 1, known: false, id: 0 },
        { name: "Blur", rank: 1, known: false, id: 0 },
        { name: "Fleetfoot", rank: 2, known: false, id: 0 },
        { name: "Fade", rank: 2, known: false, id: 0 },
        { name: "Quicken", rank: 3, known: false, id: 0 },
        { name: "Slow", rank: 4, known: false, id: 0 },
        { name: "Wormhole", rank: 4, known: false, id: 0 },
        { name: "Warpspace", rank: 5, known: false, id: 0 },
        { name: "Paradox Shot", rank: 5, known: false, id: 0 },
        { name: "Anchor", rank: 6, known: false, id: 0 },
        { name: "Warp Bolt", rank: 7, known: false, id: 0 },
        { name: "Bluefield", rank: 7, known: false, id: 0 },
        { name: "Phase", rank: 8, known: false, id: 0 },
        { name: "Arcane Pull", rank: 9, known: false, id: 0 },
        { name: "Frame Freeze", rank: 10, known: false, id: 0 },
      ],
      illusions: [
        { name: "Minor Illusion", rank: 0, known: false, id: 0 },
        { name: "Probe", rank: 1, known: false, id: 0 },
        { name: "Disguise", rank: 1, known: false, id: 0 },
        { name: "Phantasm", rank: 2, known: false, id: 0 },
        { name: "Invisibility", rank: 3, known: false, id: 0 },
        { name: "Force Illusion", rank: 3, known: false, id: 0 },
        { name: "Mirror Image", rank: 4, known: false, id: 0 },
        { name: "Emotional Trickery", rank: 5, known: false, id: 0 },
        { name: "Major Illusion", rank: 5, known: false, id: 0 },
        { name: "Doppleganger", rank: 6, known: false, id: 0 },
        { name: "Perfect Distortion", rank: 6, known: false, id: 0 },
        { name: "Focus Illusion", rank: 7, known: false, id: 0 },
        { name: "Phantasmal Evasion", rank: 8, known: false, id: 0 },
        { name: "Illusory Life", rank: 8, known: false, id: 0 },
        { name: "Phantasmal Attacker", rank: 9, known: false, id: 0 },
        { name: "Phantasmal Defender", rank: 10, known: false, id: 0 },
      ],
      scrying: [
        { name: "Alter Fate", rank: 0, known: false, id: 0 },
        { name: "Share Memory", rank: 1, known: false, id: 0 },
        { name: "Magic Sense", rank: 1, known: false, id: 0 },
        { name: "The Lovers", rank: 2, known: false, id: 0 },
        { name: "Scry", rank: 3, known: false, id: 0 },
        { name: "Meddle", rank: 3, known: false, id: 0 },
        { name: "Justice", rank: 4, known: false, id: 0 },
        { name: "Possession", rank: 4, known: false, id: 0 },
        { name: "Delve", rank: 5, known: false, id: 0 },
        { name: "The Hierophant", rank: 5, known: false, id: 0 },
        { name: "The World", rank: 6, known: false, id: 0 },
        { name: "The Devil", rank: 7, known: false, id: 0 },
        { name: "The Hermit", rank: 8, known: false, id: 0 },
        { name: "The Wheel of Fortune", rank: 8, known: false, id: 0 },
        { name: "The Magician", rank: 9, known: false, id: 0 },
        { name: "The Hanged Man", rank: 10, known: false, id: 0 },
      ],
      charms: [
        { name: "Daze", rank: 0, known: false, id: 0 },
        { name: "Shadow Thought", rank: 1, known: false, id: 0 },
        { name: "Loose Lips", rank: 1, known: false, id: 0 },
        { name: "Bend Presence", rank: 2, known: false, id: 0 },
        { name: "Twist Mind", rank: 2, known: false, id: 0 },
        { name: "Minor Charm", rank: 3, known: false, id: 0 },
        { name: "Collapse", rank: 3, known: false, id: 0 },
        { name: "Tunnel Vision", rank: 4, known: false, id: 0 },
        { name: "Witch's Power", rank: 4, known: false, id: 0 },
        { name: "Baleful Betrayal", rank: 5, known: false, id: 0 },
        { name: "Frenzy", rank: 6, known: false, id: 0 },
        { name: "Compulsion", rank: 7, known: false, id: 0 },
        { name: "Mass Confusion", rank: 7, known: false, id: 0 },
        { name: "Major Charm", rank: 8, known: false, id: 0 },
        { name: "Fate Link", rank: 9, known: false, id: 0 },
        { name: "Leech", rank: 10, known: false, id: 0 },
      ],
      astralPower: [
        { name: "Minor Orbital", rank: 0, known: false, id: 0 },
        { name: "Cosmic Lance", rank: 1, known: false, id: 0 },
        { name: "Unbound", rank: 1, known: false, id: 0 },
        { name: "Orbital", rank: 2, known: false, id: 0 },
        { name: "Wax", rank: 3, known: false, id: 0 },
        { name: "Wane", rank: 3, known: false, id: 0 },
        { name: "Singularity", rank: 4, known: false, id: 0 },
        { name: "Cosmic Force", rank: 4, known: false, id: 0 },
        { name: "Corona", rank: 5, known: false, id: 0 },
        { name: "Twilight Orbital", rank: 5, known: false, id: 0 },
        { name: "Arcane Orbital", rank: 6, known: false, id: 0 },
        { name: "Skyshatter", rank: 7, known: false, id: 0 },
        { name: "Black Hole", rank: 8, known: false, id: 0 },
        { name: "Gemini", rank: 8, known: false, id: 0 },
        { name: "Moon Prescence", rank: 9, known: false, id: 0 },
        { name: "Pulsar", rank: 10, known: false, id: 0 },
      ],
      arcana: [
        { name: "Arcane Grip", rank: 0, known: false, id: 0 },
        { name: "Telepathy", rank: 0, known: false, id: 0 },
        { name: "Sorcerous Strike", rank: 0, known: false, id: 0 },
        { name: "Forge", rank: 0, known: false, id: 0 },
        { name: "Inner Glow", rank: 0, known: false, id: 0 },
        { name: "Renew Object", rank: 0, known: false, id: 0 },
        { name: "Stabilize", rank: 0, known: false, id: 0 },
        { name: "Darken", rank: 0, known: false, id: 0 },
        { name: "Bend Elements", rank: 0, known: false, id: 0 },
        { name: "Binding", rank: 0, known: false, id: 0 },
        { name: "Assemble", rank: 0, known: false, id: 0 },
        { name: "Form Familiar", rank: 0, known: false, id: 0 },
      ],
      terramancy: [
        { name: "Harden", rank: 0, known: false, id: 0 },
        { name: "Earth Shield", rank: 1, known: false, id: 0 },
        { name: "Earth Tunnel", rank: 2, known: false, id: 0 },
        { name: "Reduction", rank: 2, known: false, id: 0 },
        { name: "Stoneskin", rank: 2, known: false, id: 0 },
        { name: "Mountain's Might", rank: 3, known: false, id: 0 },
        { name: "Tremorsense", rank: 3, known: false, id: 0 },
        { name: "Spiral Spikes", rank: 4, known: false, id: 0 },
        { name: "Cloak of Stone", rank: 4, known: false, id: 0 },
        { name: "Vigor", rank: 4, known: false, id: 0 },
        { name: "Ironskin", rank: 5, known: false, id: 0 },
        { name: "Terraform", rank: 6, known: false, id: 0 },
        { name: "Obsidian Storm", rank: 6, known: false, id: 0 },
        { name: "Deflection", rank: 7, known: false, id: 0 },
        { name: "Demolish", rank: 8, known: false, id: 0 },
        { name: "Crystal Scales", rank: 8, known: false, id: 0 },
        { name: "Field of Ruin", rank: 9, known: false, id: 0 },
        { name: "Absolute Fury", rank: 10, known: false, id: 0 },
      ],
      pyromancy: [
        { name: "Firebolt", rank: 0, known: false, id: 0 },
        { name: "Flamespike", rank: 1, known: false, id: 0 },
        { name: "Firepick", rank: 1, known: false, id: 0 },
        { name: "Smoke Cloud", rank: 2, known: false, id: 0 },
        { name: "Hand of Flame", rank: 2, known: false, id: 0 },
        { name: "Inferno", rank: 3, known: false, id: 0 },
        { name: "Flashbang", rank: 3, known: false, id: 0 },
        { name: "Rune Brand", rank: 3, known: false, id: 0 },
        { name: "Fireball", rank: 4, known: false, id: 0 },
        { name: "Cloak of Sparks", rank: 4, known: false, id: 0 },
        { name: "Cinderflame", rank: 5, known: false, id: 0 },
        { name: "Fire Control", rank: 6, known: false, id: 0 },
        { name: "Path of Light", rank: 7, known: false, id: 0 },
        { name: "Path of Flame", rank: 7, known: false, id: 0 },
        { name: "Flamestorm", rank: 8, known: false, id: 0 },
        { name: "Firelink", rank: 8, known: false, id: 0 },
        { name: "Comet", rank: 9, known: false, id: 0 },
        { name: "Flameburst Epidemic", rank: 10, known: false, id: 0 },
      ],
      aquamancy: [
        { name: "Icy Blast", rank: 0, known: false, id: 0 },
        { name: "Create Water", rank: 1, known: false, id: 0 },
        { name: "Brainfreeze", rank: 1, known: false, id: 0 },
        { name: "Waterlog", rank: 2, known: false, id: 0 },
        { name: "Effervescence", rank: 2, known: false, id: 0 },
        { name: "Hydrodisk", rank: 3, known: false, id: 0 },
        { name: "Water Wall", rank: 3, known: false, id: 0 },
        { name: "Silent Snow", rank: 3, known: false, id: 0 },
        { name: "Minor Puppet", rank: 4, known: false, id: 0 },
        { name: "Cloak of Snow", rank: 4, known: false, id: 0 },
        { name: "Whirlpool", rank: 5, known: false, id: 0 },
        { name: "Water Control", rank: 6, known: false, id: 0 },
        { name: "Freeze", rank: 7, known: false, id: 0 },
        { name: "Mass Puppet", rank: 7, known: false, id: 0 },
        { name: "Blizzard", rank: 8, known: false, id: 0 },
        { name: "Storm Bubble", rank: 8, known: false, id: 0 },
        { name: "Avalanche", rank: 9, known: false, id: 0 },
        { name: "Crystal Mirrors", rank: 10, known: false, id: 0 },
      ],
      aeromancy: [
        { name: "Voltspike", rank: 0, known: false, id: 0 },
        { name: "Blink", rank: 1, known: false, id: 0 },
        { name: "Thundering Steel", rank: 1, known: false, id: 0 },
        { name: "Flash", rank: 2, known: false, id: 0 },
        { name: "Favor of the Wind", rank: 2, known: false, id: 0 },
        { name: "Zephyr", rank: 3, known: false, id: 0 },
        { name: "Wind Wall", rank: 3, known: false, id: 0 },
        { name: "Lightning Bolt", rank: 4, known: false, id: 0 },
        { name: "Cloak of Storms", rank: 4, known: false, id: 0 },
        { name: "Hawksoar", rank: 5, known: false, id: 0 },
        { name: "Forceful Winds", rank: 5, known: false, id: 0 },
        { name: "Lightning Cascade", rank: 6, known: false, id: 0 },
        { name: "One with the Wind", rank: 7, known: false, id: 0 },
        { name: "Gathering Winds", rank: 7, known: false, id: 0 },
        { name: "Chain Lightning", rank: 8, known: false, id: 0 },
        { name: "Thunderlink", rank: 8, known: false, id: 0 },
        { name: "Warp Lightning", rank: 9, known: false, id: 0 },
        { name: "Gathering Storm", rank: 10, known: false, id: 0 },
      ],
    },
    divineSpellgroups: {
      life: [
        { name: "Helping Hand", rank: 0, known: false, id: 0 },
        { name: "Healing Touch", rank: 1, known: false, id: 0 },
        { name: "Assert Order", rank: 1, known: false, id: 0 },
        { name: "Refresh", rank: 2, known: false, id: 0 },
        { name: "Honor Guard", rank: 2, known: false, id: 0 },
        { name: "Rejuvenating Ray", rank: 3, known: false, id: 0 },
        { name: "Willing Sacrifice", rank: 3, known: false, id: 0 },
        { name: "Major Preservation", rank: 4, known: false, id: 0 },
        { name: "Physician's Poppet", rank: 4, known: false, id: 0 },
        { name: "Purge", rank: 5, known: false, id: 0 },
        { name: "Righteousness", rank: 6, known: false, id: 0 },
        { name: "Assert Life", rank: 6, known: false, id: 0 },
        { name: "Lifeline", rank: 7, known: false, id: 0 },
        { name: "Avatar", rank: 8, known: false, id: 0 },
        { name: "Lifeplate", rank: 8, known: false, id: 0 },
        { name: "Mass Heal", rank: 9, known: false, id: 0 },
        { name: "Bastion of Dawn", rank: 9, known: false, id: 0 },
        { name: "Hallowed Stance", rank: 10, known: false, id: 0 },
      ],
      light: [
        { name: "Guiding Light", rank: 0, known: false, id: 0 },
        { name: "Piercing Light", rank: 1, known: false, id: 0 },
        { name: "Blinding Furor", rank: 1, known: false, id: 0 },
        { name: "Radiant Ramient", rank: 2, known: false, id: 0 },
        { name: "Divine Dawn", rank: 2, known: false, id: 0 },
        { name: "Reviere", rank: 3, known: false, id: 0 },
        { name: "Rebuke", rank: 3, known: false, id: 0 },
        { name: "Lightspectre", rank: 4, known: false, id: 0 },
        { name: "Direct Light", rank: 4, known: false, id: 0 },
        { name: "Blind", rank: 5, known: false, id: 0 },
        { name: "Divine Strike", rank: 5, known: false, id: 0 },
        { name: "Radiance", rank: 6, known: false, id: 0 },
        { name: "Reflection", rank: 7, known: false, id: 0 },
        { name: "Banish", rank: 7, known: false, id: 0 },
        { name: "Radiant Command", rank: 8, known: false, id: 0 },
        { name: "Last Vigil", rank: 8, known: false, id: 0 },
        { name: "Celestial Sphere", rank: 9, known: false, id: 0 },
        { name: "Stardust Pulse", rank: 10, known: false, id: 0 },
      ],
      death: [
        { name: "Rot", rank: 0, known: false, id: 0 },
        { name: "Life Drain", rank: 1, known: false, id: 0 },
        { name: "Soul Grip", rank: 1, known: false, id: 0 },
        { name: "Curse of Steel", rank: 2, known: false, id: 0 },
        { name: "Deathplague", rank: 2, known: false, id: 0 },
        { name: "Curse of Sleep", rank: 3, known: false, id: 0 },
        { name: "Infuse Plague", rank: 3, known: false, id: 0 },
        { name: "Soul Command", rank: 4, known: false, id: 0 },
        { name: "Curse of Knowledge", rank: 4, known: false, id: 0 },
        { name: "Curseplague", rank: 5, known: false, id: 0 },
        { name: "Curse of Death", rank: 5, known: false, id: 0 },
        { name: "Mass Life Drain", rank: 6, known: false, id: 0 },
        { name: "Scourge", rank: 6, known: false, id: 0 },
        { name: "Curse of Lethargy", rank: 7, known: false, id: 0 },
        { name: "Blightfall", rank: 8, known: false, id: 0 },
        { name: "Soul Drain", rank: 9, known: false, id: 0 },
        { name: "Harvest Soul", rank: 9, known: false, id: 0 },
        { name: "Dust to Dust", rank: 10, known: false, id: 0 },
      ],
      darkness: [
        { name: "Shadowsight", rank: 0, known: false, id: 0 },
        { name: "Shadow Slick", rank: 1, known: false, id: 0 },
        { name: "Dark Echo", rank: 1, known: false, id: 0 },
        { name: "Stygian Blur", rank: 2, known: false, id: 0 },
        { name: "Hopelessness", rank: 2, known: false, id: 0 },
        { name: "Stifling Shadow", rank: 3, known: false, id: 0 },
        { name: "Darkport", rank: 3, known: false, id: 0 },
        { name: "Shadowflash", rank: 4, known: false, id: 0 },
        { name: "Umbrapush", rank: 4, known: false, id: 0 },
        { name: "Shadow Poppet", rank: 5, known: false, id: 0 },
        { name: "Grappling Darkness", rank: 6, known: false, id: 0 },
        { name: "Umbral Momentum", rank: 6, known: false, id: 0 },
        { name: "Shade", rank: 7, known: false, id: 0 },
        { name: "Confusing Darkness", rank: 7, known: false, id: 0 },
        { name: "Shadow Servants", rank: 8, known: false, id: 0 },
        { name: "Dark Bastion", rank: 8, known: false, id: 0 },
        { name: "Eternal Darkness", rank: 9, known: false, id: 0 },
        { name: "Shadowform", rank: 10, known: false, id: 0 },
      ],
      flora: [
        { name: "Rampant Verdance", rank: 0, known: false, id: 0 },
        { name: "Seed Scatter", rank: 1, known: false, id: 0 },
        { name: "Wild Growth", rank: 1, known: false, id: 0 },
        { name: "Lazarite Growth", rank: 2, known: false, id: 0 },
        { name: "Verdure Movement", rank: 2, known: false, id: 0 },
        { name: "Piercing Vine", rank: 3, known: false, id: 0 },
        { name: "Blessing of Creation", rank: 3, known: false, id: 0 },
        { name: "Destructive Verdance", rank: 4, known: false, id: 0 },
        { name: "Entangle", rank: 5, known: false, id: 0 },
        { name: "Underbrush", rank: 5, known: false, id: 0 },
        { name: "Regrowth", rank: 6, known: false, id: 0 },
        { name: "Bladeleaf Aura", rank: 7, known: false, id: 0 },
        { name: "Plant Control", rank: 7, known: false, id: 0 },
        { name: "Overgrowth", rank: 8, known: false, id: 0 },
        { name: "Parasitic Growth", rank: 8, known: false, id: 0 },
        { name: "Plantkin", rank: 9, known: false, id: 0 },
        { name: "Ebb and Flow", rank: 9, known: false, id: 0 },
        { name: "Creeping Consumption", rank: 10, known: false, id: 0 },
      ],
      fauna: [
        { name: "Adaptation", rank: 0, known: false, id: 0 },
        { name: "Maul", rank: 0, known: false, id: 0 },
        { name: "Wolf  /  Bear", rank: 1, known: false, id: 0 },
        { name: "Gr Butterfly / Gr Raven", rank: 1, known: false, id: 0 },
        { name: "Great Wolf / Great Bear", rank: 2, known: false, id: 0 },
        { name: "Mawfly / Eruraven", rank: 2, known: false, id: 0 },
        { name: "Transformation", rank: 3, known: false, id: 0 },
        { name: "Polymorph", rank: 3, known: false, id: 0 },
        { name: "Leechwolf / Earthenbear", rank: 4, known: false, id: 0 },
        { name: "Solar Starfly / Roc", rank: 4, known: false, id: 0 },
        { name: "Duskhunter / Elemental", rank: 5, known: false, id: 0 },
        { name: "Astral / Strygarii", rank: 5, known: false, id: 0 },
      ],
      tempest: [
        { name: "Lightning Whip", rank: 0, known: false, id: 0 },
        { name: "Zap", rank: 1, known: false, id: 0 },
        { name: "Eye of the Storm", rank: 1, known: false, id: 0 },
        { name: "Cyclone", rank: 2, known: false, id: 0 },
        { name: "Pulse", rank: 2, known: false, id: 0 },
        { name: "Lightning Reflexes", rank: 3, known: false, id: 0 },
        { name: "Uplift", rank: 3, known: false, id: 0 },
        { name: "Gaseous Form", rank: 4, known: false, id: 0 },
        { name: "Current", rank: 5, known: false, id: 0 },
        { name: "Stormcaller", rank: 5, known: false, id: 0 },
        { name: "Dispersal", rank: 6, known: false, id: 0 },
        { name: "Static Charge", rank: 6, known: false, id: 0 },
        { name: "Unhittable", rank: 7, known: false, id: 0 },
        { name: "Amorphous Weapon", rank: 8, known: false, id: 0 },
        { name: "Vortex", rank: 8, known: false, id: 0 },
        { name: "Cloudburst", rank: 9, known: false, id: 0 },
        { name: "Storm", rank: 9, known: false, id: 0 },
        { name: "Tempest", rank: 10, known: false, id: 0 },
      ],
      turmoil: [
        { name: "Primordial Sphere", rank: 0, known: false, id: 0 },
        { name: "Ignition", rank: 1, known: false, id: 0 },
        { name: "Chaos Bolt", rank: 1, known: false, id: 0 },
        { name: "Random Spell", rank: 2, known: false, id: 0 },
        { name: "Chaos Inversion", rank: 2, known: false, id: 0 },
        { name: "Chaos Shield", rank: 3, known: false, id: 0 },
        { name: "Unstable Presence", rank: 3, known: false, id: 0 },
        { name: "Vernal Defense", rank: 4, known: false, id: 0 },
        { name: "Super Chaos", rank: 5, known: false, id: 0 },
        { name: "Outer Chaos", rank: 5, known: false, id: 0 },
        { name: "Erratic Odds", rank: 6, known: false, id: 0 },
        { name: "Chaos Curse", rank: 6, known: false, id: 0 },
        { name: "Disordered Alignment", rank: 7, known: false, id: 0 },
        { name: "Chaos Control", rank: 7, known: false, id: 0 },
        { name: "Reality Tear", rank: 8, known: false, id: 0 },
        { name: "Chaos Incarnate", rank: 9, known: false, id: 0 },
        { name: "Meteoric Acceleration", rank: 9, known: false, id: 0 },
        { name: "Pandemonium", rank: 10, known: false, id: 0 },
      ],
      equillibrium: [
        { name: "Twilight Flurry", rank: 0, known: false, id: 0 },
        { name: "Share Vision", rank: 1, known: false, id: 0 },
        { name: "Life Transfer", rank: 1, known: false, id: 0 },
        { name: "Shared Burden", rank: 2, known: false, id: 0 },
        { name: "Energy Transfer", rank: 2, known: false, id: 0 },
        { name: "Forcerush", rank: 3, known: false, id: 0 },
        { name: "Incantation", rank: 3, known: false, id: 0 },
        { name: "Pandemonium", rank: 4, known: false, id: 0 },
        { name: "Energy Conversion", rank: 4, known: false, id: 0 },
        { name: "Prismatic Volley", rank: 5, known: false, id: 0 },
        { name: "Displacement Orb", rank: 5, known: false, id: 0 },
        { name: "Meld", rank: 6, known: false, id: 0 },
        { name: "Balance", rank: 6, known: false, id: 0 },
        { name: "Link Vitality", rank: 7, known: false, id: 0 },
        { name: "Energy Reset", rank: 8, known: false, id: 0 },
        { name: "Copycast", rank: 9, known: false, id: 0 },
        { name: "Halflight Lance", rank: 9, known: false, id: 0 },
        { name: "Celestial Alignment", rank: 10, known: false, id: 0 },
      ],
      effigy: [
        { name: "Forge Effigy", rank: 0, known: false, id: 0 },
        { name: "Direction", rank: 0, known: false, id: 0 },
        { name: "Vigilance", rank: 1, known: false, id: 0 },
        { name: "Transposition", rank: 1, known: false, id: 0 },
        { name: "Sensation", rank: 2, known: false, id: 0 },
        { name: "Artifact", rank: 2, known: false, id: 0 },
        { name: "Aspect", rank: 3, known: false, id: 0 },
        { name: "Attunement", rank: 3, known: false, id: 0 },
        { name: "Replicate", rank: 4, known: false, id: 0 },
        { name: "Overload", rank: 4, known: false, id: 0 },
        { name: "Empowered Effigy", rank: 5, known: false, id: 0 },
        { name: "Synthesis", rank: 5, known: false, id: 0 },
      ],
    },
  }),
  getters: {
    arcaneBattery: (state: SpellsStore) => {
      return state.arcaneBattery;
    },
    arcaneBatteryId: (state: SpellsStore) => {
      return state.arcaneBatteryId;
    },
    knownElementalSpellgroups: (state: SpellsStore) => {
      const ret = [];
      for (const spellgroup in state.elementalSpellgroups) {
        for (const spell of state.elementalSpellgroups[
          spellgroup as keyof SpellsStore["elementalSpellgroups"]
        ]) {
          if (spell.known) {
            ret.push(spellgroup);
            break;
          }
        }
      }
      return ret;
    },
    knownDivineSpellgroups: (state: SpellsStore) => {
      const ret = [];
      for (const spellgroup in state.divineSpellgroups) {
        for (const spell of state.divineSpellgroups[
          spellgroup as keyof SpellsStore["divineSpellgroups"]
        ]) {
          if (spell.known) {
            ret.push(spellgroup);
            break;
          }
        }
      }
      return ret;
    },
    elementalSpellgroups: (state: SpellsStore) => {
      return { ...state.elementalSpellgroups };
    },
    interdictions: (state: SpellsStore) => {
      const temp = { ...state.elementalSpellgroups };
      return temp["interdictions"];
    },
    spaceTime: (state: SpellsStore) => {
      const temp = { ...state.elementalSpellgroups };
      return temp["spaceTime"];
    },
    illusions: (state: SpellsStore) => {
      const temp = { ...state.elementalSpellgroups };
      return temp["illusions"];
    },
    scrying: (state: SpellsStore) => {
      const temp = { ...state.elementalSpellgroups };
      return temp["scrying"];
    },
    charms: (state: SpellsStore) => {
      const temp = { ...state.elementalSpellgroups };
      return temp["charms"];
    },
    astralPower: (state: SpellsStore) => {
      const temp = { ...state.elementalSpellgroups };
      return temp["astralPower"];
    },
    arcana: (state: SpellsStore) => {
      const temp = { ...state.elementalSpellgroups };
      return temp["arcana"];
    },
    terramancy: (state: SpellsStore) => {
      const temp = { ...state.elementalSpellgroups };
      return temp["terramancy"];
    },
    pyromancy: (state: SpellsStore) => {
      const temp = { ...state.elementalSpellgroups };
      return temp["pyromancy"];
    },
    aquamancy: (state: SpellsStore) => {
      const temp = { ...state.elementalSpellgroups };
      return temp["aquamancy"];
    },
    aeromancy: (state: SpellsStore) => {
      const temp = { ...state.elementalSpellgroups };
      return temp["aeromancy"];
    },
    divineSpellgroups: (state: SpellsStore) => {
      return state.divineSpellgroups;
    },
    life: (state: SpellsStore) => {
      const temp = { ...state.divineSpellgroups };
      return temp["life"];
    },
    light: (state: SpellsStore) => {
      const temp = { ...state.divineSpellgroups };
      return temp["light"];
    },
    death: (state: SpellsStore) => {
      const temp = { ...state.divineSpellgroups };
      return temp["death"];
    },
    darkness: (state: SpellsStore) => {
      const temp = { ...state.divineSpellgroups };
      return temp["darkness"];
    },
    tempest: (state: SpellsStore) => {
      const temp = { ...state.divineSpellgroups };
      return temp["tempest"];
    },
    turmoil: (state: SpellsStore) => {
      const temp = { ...state.divineSpellgroups };
      return temp["turmoil"];
    },
    flora: (state: SpellsStore) => {
      const temp = { ...state.divineSpellgroups };
      return temp["flora"];
    },
    fauna: (state: SpellsStore) => {
      const temp = { ...state.divineSpellgroups };
      return temp["fauna"];
    },
    equillibrium: (state: SpellsStore) => {
      const temp = { ...state.divineSpellgroups };
      return temp["equillibrium"];
    },
    effigy: (state: SpellsStore) => {
      const temp = { ...state.divineSpellgroups };
      return temp["effigy"];
    },
    spells: (state: SpellsStore) => {
      return {
        elementalSpellgroups: state.elementalSpellgroups,
        divineSpellgroups: state.divineSpellgroups,
      };
    },
  },
  mutations: {
    setArcaneBattery: (state: SpellsStore, newData: number) => {
      state.arcaneBattery = newData;
    },
    setArcaneBatteryId: (state: SpellsStore, newData: number) => {
      state.arcaneBatteryId = newData;
    },
    setElementalSpellgroups: (
      state: SpellsStore,
      newData: {
        interdictions: Array<SpellItemStore>;
        spaceTime: Array<SpellItemStore>;
        illusions: Array<SpellItemStore>;
        scrying: Array<SpellItemStore>;
        charms: Array<SpellItemStore>;
        astralPower: Array<SpellItemStore>;
        arcana: Array<SpellItemStore>;
        terramancy: Array<SpellItemStore>;
        pyromancy: Array<SpellItemStore>;
        aquamancy: Array<SpellItemStore>;
        aeromancy: Array<SpellItemStore>;
      }
    ) => {
      state.elementalSpellgroups = newData;
    },
    setDivineSpellgroups: (
      state: SpellsStore,
      newData: {
        life: Array<SpellItemStore>;
        light: Array<SpellItemStore>;
        death: Array<SpellItemStore>;
        darkness: Array<SpellItemStore>;
        flora: Array<SpellItemStore>;
        fauna: Array<SpellItemStore>;
        tempest: Array<SpellItemStore>;
        turmoil: Array<SpellItemStore>;
        equillibrium: Array<SpellItemStore>;
        effigy: Array<SpellItemStore>;
      }
    ) => {
      state.divineSpellgroups = newData;
    },
    setElementalSpell: (state: SpellsStore, spellData: any) => {
      if (
        state.elementalSpellgroups[
          spellData.spellgroup as keyof SpellsStore["elementalSpellgroups"]
        ][spellData.i].id == 0
      ) {
        state.elementalSpellgroups[
          spellData.spellgroup as keyof SpellsStore["elementalSpellgroups"]
        ][spellData.i].id = spellData.id;
      }
      if (spellData.spellgroup === "arcana") {
        state.elementalSpellgroups[
          spellData.spellgroup as keyof SpellsStore["elementalSpellgroups"]
        ][spellData.i].known = spellData.known;
      } else {
        state.elementalSpellgroups[
          spellData.spellgroup as keyof SpellsStore["elementalSpellgroups"]
        ][spellData.i].known = spellData.known;
        state.elementalSpellgroups[
          spellData.spellgroup as keyof SpellsStore["elementalSpellgroups"]
        ][0].known =
          state.elementalSpellgroups[
            spellData.spellgroup as keyof SpellsStore["elementalSpellgroups"]
          ][1].known ||
          state.elementalSpellgroups[
            spellData.spellgroup as keyof SpellsStore["elementalSpellgroups"]
          ][2].known ||
          state.elementalSpellgroups[
            spellData.spellgroup as keyof SpellsStore["elementalSpellgroups"]
          ][3].known;
      }
    },
    setDivineSpell: (state: SpellsStore, spellData: any) => {
      state.divineSpellgroups[
        spellData.spellgroup as keyof SpellsStore["divineSpellgroups"]
      ][spellData.i].id = spellData.id;
      if (
        spellData.spellgroup === "fauna" ||
        spellData.spellgroup === "effigy"
      ) {
        state.divineSpellgroups[
          spellData.spellgroup as keyof SpellsStore["divineSpellgroups"]
        ][spellData.i].known = spellData.known;
        state.divineSpellgroups[
          spellData.spellgroup as keyof SpellsStore["divineSpellgroups"]
        ][0].known =
          state.divineSpellgroups[
            spellData.spellgroup as keyof SpellsStore["divineSpellgroups"]
          ][2].known ||
          state.divineSpellgroups[
            spellData.spellgroup as keyof SpellsStore["divineSpellgroups"]
          ][3].known;
        state.divineSpellgroups[
          spellData.spellgroup as keyof SpellsStore["divineSpellgroups"]
        ][1].known =
          state.divineSpellgroups[
            spellData.spellgroup as keyof SpellsStore["divineSpellgroups"]
          ][2].known ||
          state.divineSpellgroups[
            spellData.spellgroup as keyof SpellsStore["divineSpellgroups"]
          ][3].known;
      } else {
        state.divineSpellgroups[
          spellData.spellgroup as keyof SpellsStore["divineSpellgroups"]
        ][spellData.i].known = spellData.known;
        state.divineSpellgroups[
          spellData.spellgroup as keyof SpellsStore["divineSpellgroups"]
        ][0].known =
          state.divineSpellgroups[
            spellData.spellgroup as keyof SpellsStore["divineSpellgroups"]
          ][1].known ||
          state.divineSpellgroups[
            spellData.spellgroup as keyof SpellsStore["divineSpellgroups"]
          ][2].known ||
          state.divineSpellgroups[
            spellData.spellgroup as keyof SpellsStore["divineSpellgroups"]
          ][3].known;
      }
    },
    clearElementalSpells: (state: SpellsStore) => {
      const arr = Object.keys(state.elementalSpellgroups);
      for (const spellgroup of arr) {
        for (let i = 0; i < spellgroup.length; i++) {
          state.elementalSpellgroups[
            spellgroup as keyof SpellsStore["elementalSpellgroups"]
          ][i].known = false;
        }
      }
    },
    clearDivineSpells: (state: SpellsStore) => {
      const arr = Object.keys(state.divineSpellgroups);
      for (const spellgroup of arr) {
        for (let i = 0; i < spellgroup.length; i++) {
          state.divineSpellgroups[
            spellgroup as keyof SpellsStore["divineSpellgroups"]
          ][i].known = false;
        }
      }
    },
  },
  actions: {
    updateArcaneBattery: (
      context: any,
      newData: {
        charge: number;
        character_id: string;
      }
    ) => {
      if (context.getters.arcaneBattery > 0) {
        deleteSpells(
          newData.character_id,
          "Arcane Battery",
          "I make my own rules hoebag",
          "Arcane Battery",
          context.getters.arcaneBattery,
          context.getters.arcaneBatteryId
        );
      }
      if (newData.charge >= 1) {
        putSpell(
          newData.character_id,
          "Arcane Battery",
          "I make my own rules hoebag",
          "Arcane Battery",
          newData.charge,
          context.getters.arcaneBatteryId
        ).then((response) => {
          context.commit("setArcaneBatteryId", response.data[0].id);
        });
      }
      context.commit("setArcaneBattery", newData.charge);
    },
    updateElementalSpell: (
      context: any,
      newData: {
        known: boolean;
        i: number;
        spellgroup: string;
        character_id: string;
        id: number;
      }
    ) => {
      const spellData =
        context.getters.elementalSpellgroups[
          newData.spellgroup as keyof SpellsStore["elementalSpellgroups"]
        ][newData.i];
      console.log(spellData);
      const payload = {
        known: newData.known,
        i: newData.i,
        spellgroup: newData.spellgroup,
        id: spellData.id,
      };
      const name = spellData.name;
      const rank = spellData.rank;
      const id = spellData.id;
      if (!newData.known) {
        deleteSpells(
          newData.character_id,
          "elementalSpellgroups",
          newData.spellgroup,
          name,
          rank,
          spellData.id
        );
        context.commit("setElementalSpell", payload);
      } else {
        putSpell(
          newData.character_id,
          "elementalSpellgroups",
          newData.spellgroup,
          name,
          rank,
          id
        ).then((response) => {
          payload.id = response.data[0].id;
          context.commit("setElementalSpell", payload);
        });
      }
    },
    updateDivineSpell: (
      context: any,
      newData: {
        known: boolean;
        i: number;
        spellgroup: string;
        character_id: string;
        id: number;
      }
    ) => {
      const spellData =
        context.getters.divineSpellgroups[
          newData.spellgroup as keyof SpellsStore["divineSpellgroups"]
        ][newData.i];
      const name = spellData.name;
      const rank = spellData.rank;
      const id = spellData.id;
      const payload = {
        known: newData.known,
        i: newData.i,
        spellgroup: newData.spellgroup,
        id: spellData.id,
      };
      if (!newData.known) {
        deleteSpells(
          newData.character_id,
          "divineSpellgroups",
          newData.spellgroup,
          name,
          rank,
          spellData.id
        );
        context.commit("setDivineSpell", payload);
      } else {
        putSpell(
          newData.character_id,
          "divineSpellgroups",
          newData.spellgroup,
          name,
          rank,
          id
        ).then((response) => {
          payload.id = response.data[0].id;
          context.commit("setDivineSpell", payload);
        });
      }
    },
    toggleSpell: (
      context: {
        state: { elementalSpellgroups: any };
        commit: (arg0: string, arg1: any) => void;
      },
      newData: { spellgroup: string | number; i: string | number; known: any }
    ) => {
      const temp = {
        ...context.state.elementalSpellgroups,
      };
      temp[newData.spellgroup][newData.i].known = newData.known;
      temp[newData.spellgroup][0].known =
        temp[newData.spellgroup][1].known ||
        temp[newData.spellgroup][2].known ||
        temp[newData.spellgroup][3].known;
      context.commit("setElementalSpellgroups", temp);
    },
    toggleDivineSpell: (
      context: {
        state: { divineSpellgroups: any };
        commit: (arg0: string, arg1: any) => void;
      },
      newData: { spellgroup: string | number; i: string | number; known: any }
    ) => {
      const temp = {
        ...context.state.divineSpellgroups,
      };
      temp[newData.spellgroup][newData.i].known = newData.known;
      if (temp[newData.spellgroup][1].rank === 0) {
        temp[newData.spellgroup][1].known =
          temp[newData.spellgroup][2].known ||
          temp[newData.spellgroup][3].known;
      }
      temp[newData.spellgroup][0].known =
        temp[newData.spellgroup][1].known ||
        temp[newData.spellgroup][2].known ||
        temp[newData.spellgroup][3].known;
      context.commit("setDivineSpellgroups", temp);
    },
  },
};
